import { render, staticRenderFns } from "./layout-text-cl.vue?vue&type=template&id=98164a54"
import script from "./layout-text-cl.vue?vue&type=script&lang=js"
export * from "./layout-text-cl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports